import { FC, useEffect, useMemo, useRef } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { AIChatbotResponse } from '../../types';
import { ChatMessage } from './chat-message';

interface ChatMessageListProps {
  messages: AIChatbotResponse[];
}

export const ChatMessageList: FC<ChatMessageListProps> = ({ messages }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const latestUserMessageRef = useRef<HTMLDivElement>(null);
  const lastMessagesCountRef = useRef(messages.length);

  const latestUserMessageIndex = useMemo(() => {
    return messages.findLastIndex((msg) => msg.role === 'user');
  }, [messages]);

  useEffect(() => {
    const hasNewMessage = lastMessagesCountRef.current !== messages.length;
    if (hasNewMessage) {
      lastMessagesCountRef.current = messages.length;
      latestUserMessageRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [messages.length]);

  return (
    <div css={styles.container} ref={containerRef}>
      {messages.map((message, index) => (
        <ChatMessage
          key={index}
          chatbotResponse={message}
          innerRef={latestUserMessageIndex === index ? latestUserMessageRef : null}
        />
      ))}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    margin: ${theme.spacing(0, 2)};
    gap: ${theme.spacing(2)};
  `,
};
